<!-- src/components/NavBar.vue -->
<template>
  <v-app-bar :elevation="4" flat class="navbar-red">
    <!-- Menú hamburguesa -->
    <v-app-bar-nav-icon
      color="white"
      variant="text"
      @click="$emit('toggle-drawer')"
    ></v-app-bar-nav-icon>

    <!-- Título de la app -->

    <v-app-bar-title class="text-uppercase">
       <div style="align-items: start; display: flex; justify-content: flex-start; margin-left: 15%;"  > <TemaApp /></div>
      <!-- <img
        :src="require('@/assets/prometheus.png')"
        alt="icono"
        style="
          height: 45px;
          width: 45px;
          border-radius: 50%;
          background: #fff;
          padding: 3px;
          object-fit: contain;
        "
      /> -->
    </v-app-bar-title>

    <!--Esto son acciones que se pueden tener con botones de iconos-->
    <template v-slot:append>
     
     
      <!-- <v-btn icon="mdi-heart" ></v-btn> -->

      <!-- <v-btn color="white" icon="mdi-magnify"></v-btn> -->

      <!-- <v-btn color="white" icon="mdi-dots-vertical"></v-btn> -->
      <!-- Botón de logout -->
      <v-spacer></v-spacer>
      <!-- <v-btn icon @click="logout"> -->
      <v-menu>
        <template v-slot:activator="{ props }">
          <v-btn icon v-bind="props">
            <v-icon color="white"   style="background-color: #1C4597; border: 5px solid white; border-radius: 5px;     border: 1px solid white; padding: 18px;
"
>mdi-account</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            v-for="(item, index) in items"
            :key="index"
            :value="index"
            @click="handleClick(item)"
          >
            <v-list-item-title>
              <v-icon>{{ item.icono }}</v-icon>
              {{ item.title }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
  </v-app-bar>
</template>

<script>
import api from "@/api/axios/axios.js";
import TemaApp from "./TemaApp.vue";
import { useAuthStore } from "@/stores/auth";

export default {
  name: "NavBar",
  components: {
    TemaApp,
  },
  data() {
    return {};
  },
  computed: {
    items() {
      //console.log('Traducción de perfil:', this.$t('perfil'))

      return [
        { title: this.$t("perfil"), icono: "mdi-account" },
        //{ title: this.$t('conf'),icono:'mdi-cog' },
        { title: this.$t("cerrar"), icono: "mdi-logout" },
      ];
    },
  },
  methods: {
    async logout() {
      try {
        await api.post("/login/logout/");
        //console.log("Se hace logout")
        // Limpiamos el rol/estado para que no quede pegado en la proxima sesion.
        useAuthStore().clear();
        localStorage.removeItem("role");
        localStorage.removeItem("token_exp");
        this.$router.push({
          path: "/index",
          query: { mensaje: "Sesión cerrada con éxito" },
        });
      } catch (err) {
        console.error("Error al cerrar sesión", err);
      }
    },
    handleClick(item) {
      //console.log("DDDD")
      //console.log(item.title)
      if (item.title === "Cerrar Sesión" || item.title === "Log Out") {
        this.logout();
      } else {
        this.$router.push({ name: "ProfileView" });
      }
    },
  },
};
</script>

<style scoped>
/* NavBar rojo con un rojo que armoniza con azul/navy (familia 780000-c1121f).
   Degradado profundo y elegante, con un borde inferior mas oscuro de remate. */
.navbar-red {
  background: #1C4597;
  color: #fff !important;
  border-bottom: 2px solid rgba(239, 240, 243, 0.598) !important;
}
.navbar-red :deep(.v-toolbar__content) {
  color: #fff !important;
}
</style>
